export enum Theme {
	Light = 'light',
	Dark = 'dark',
}

export type ThemeUserSettings = {
	theme?: Theme;
};
